// Components/ui
import { Box } from '@mui/material';
import { SubsectionHeaderWithButton } from '../../layout';
import { Body } from './components';
// Types
import { NewAddress } from '../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  emails: Array<NewAddress | IContactAddress>;
  handleAdd: () => void;
};
const Mails = ({ emails, handleAdd }: Props) => {
  return (
    <Box sx={{ width: '100%' }}>
      <SubsectionHeaderWithButton handleAdd={handleAdd} title={'Emails'} />
      <Body emails={emails} />
    </Box>
  );
};

export default Mails;
